import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { activeDeliveryAreas as getActiveDeliveryAreas } from 'garaje/utils/delivery-area';

export default class DeliveriesDeliveryAreaGatingModal extends Component {
  @service abilities;
  @service featureFlags;
  @service router;
  @service state;
  @service store;

  @tracked closed = false;

  get activeDeliveryAreas() {
    // Use the shared helper so this count matches the deliveries settings surfaces
    // (and the backend/Retool). `peekAll` alone over-counts: it includes unsaved
    // (isNew) records — which materialize with `enabled` defaulting to true — and
    // ignores the locationBilling scoping the other surfaces apply.
    //
    // Note: this modal only renders under legacy company-level billing — the
    // `showDeliveryAreaGatingModal` gate in the protected controller returns false when
    // `locationBilling` is on — so in practice this always resolves to the company-wide
    // count. The flag is still passed for consistency with the other surfaces.
    return getActiveDeliveryAreas(this.store.peekAll('delivery-area'), {
      locationBilling: this.featureFlags.isEnabled('locationBilling'),
      currentLocationId: this.state.currentLocation?.id,
    });
  }

  get subscription() {
    return this.state.deliveriesSubscription;
  }

  get isCompliant() {
    if (!this.subscription) return true;
    return this.activeDeliveryAreas.length <= this.subscription.quantity;
  }

  get excessCount() {
    return Math.max(0, this.activeDeliveryAreas.length - (this.subscription?.quantity ?? 0));
  }

  get shouldDisplay() {
    return this.subscription && !this.closed;
  }

  get contentComponent() {
    if (this.abilities.can('disable delivery-area')) {
      return 'deliveries/delivery-area-gating-modal/billing-admin';
    }
    return 'deliveries/delivery-area-gating-modal/non-billing-admin';
  }

  @action
  close() {
    this.closed = true;
  }

  @action
  onClose() {
    // Hard gate — no soft dismiss. Redirect the user away from deliveries.
    this.closed = true;
    this.router.transitionTo('protected');
  }
}
